var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "canvas-container" }, [
    _c("canvas", { ref: "bjsCanvas", staticClass: "full-screen-canvas" }),
    _c(
      "button",
      { staticClass: "toggle-button", on: { click: _vm.toggleOthers } },
      [
        _vm._v(
          " " + _vm._s(_vm.othersVisible ? "Hide Others" : "Show Others") + " "
        ),
      ]
    ),
    _vm.loading
      ? _c("div", { staticClass: "loading-overlay" }, [
          _c("div", { staticClass: "loading-text" }, [
            _vm._v("Locating Object"),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }